<template>
    <form>
        <fieldset>
            <legend>{{Language.say('settings.browser_notifications.description')}}</legend>

            <ul class="border-list">
                <li>
                    <div class="control-group">
                        <div class="control toggle-button" @click="onTogglePermissions()">
                            <input
                                id="tg_son"
                                type="checkbox"
                                tabindex="-1"
                                :disabled="browser_notifications_controller.blocked || !browser_notifications_controller.supported"
                                :checked="browser_notifications_controller.enabled"
                            >
                            <label for="tg_son">
                                <div class="label-text">
                                    {{Language.say('settings.browser_notifications.enable')}}
                                </div>
                                <div class="switch"></div>
                            </label>
                        </div>
                    </div>
                </li>
            </ul>   

            <div class="container-alert inline top-space">

                <div class="alert warning" v-if="browser_notifications_controller.blocked === true">
                    <div class="alert-icon">
                        <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                    </div>
                    <div class="content">
                        {{Language.say('settings.browser_notifications.info_blocked_1')}} <br>
                        {{Language.say('settings.browser_notifications.info_blocked_2')}}
                    </div>
                </div>

                <div class="alert warning" v-if="browser_notifications_controller.supported === false">
                    <div class="alert-icon">
                        <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                    </div>
                    <div class="content">
                        {{Language.say('settings.browser_notifications.not_supported_1')}}
                    </div>
                </div>

                <div class="alert"  v-if="browser_notifications_controller.enabled === false && browser_notifications_controller.supported === true">
                    <div class="alert-icon">
                        <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                    </div>
                    <div class="content">
                        {{Language.say('settings.browser_notifications.info_click')}}
                    </div>
                </div>

                <div class="alert" v-if="browser_notifications_controller.supported === true">
                    <div class="alert-icon">
                        <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                    </div>
                    <div class="content">
                        {{Language.say('settings.browser_notifications.info_devices')}}
                    </div>
                </div>

            </div>
        </fieldset>

    </form>
    <div class="overlay notify" v-if="overlay_visible" style="display: block;">
        <div class="info">
            <p>Clique no botão “Permitir” para subscrever as notificações</p>
            <img src="css/notifications-helper.svg" alt="Notificações" />
        </div>
    </div>
</template>

<script setup>
    import {reactive, ref}                from 'vue';
    import Language                       from '@/js/Shared/Language/Language.js';
    import BrowserNotificationsController from '@/js/Webmail/Notifications/BrowserNotificationsController';

    const browser_notifications_controller = reactive(BrowserNotificationsController);
    const overlay_visible                  = ref(false);

    const onTogglePermissions = async () => {
        if (browser_notifications_controller.blocked) {
            return;
        }

        if (!browser_notifications_controller.enabled && browser_notifications_controller.api.permission !== 'granted') {
            setOverlayVisibility(true);
        }

        await browser_notifications_controller.requestPermission();
        setOverlayVisibility(false);
    }

    const setOverlayVisibility = (value) => {
        overlay_visible.value = value;
    }

</script>
